<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="context.langObj['title']"
        :description="context.langObj['titleDescription']"
        :has-back="hasBack"
        @back="back"
      >
        <template #form>
          <ResetForm ref="form" :context="context" :type="'email'" />
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>

<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import ResetForm from './ResetForm.vue'
import settings from '@/settings.js'

export default {
  name: '',
  props: {
    context: {
      type: Object,
      require: true,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },

  components: { LoginLayout, LoginContainer, ResetForm },

  computed: {
    hasBack() {
      const index = settings.resetPasswordRouterParams.indexOf(
        this.$route.params.step
      )
      return index === -1 ? 0 : index
    },
  },

  methods: {
    back() {
      this.$router.replace({
        path: '/cim/reset_password/email/account/',
        query: { ...this.$route.query },
      })
      this.$refs['form'].clearDetail()
    },
  },
}
</script>
<style lang="scss" scoped></style>
